import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { getVariantPath } from '@uswitch/spark.utils';
import PropTypes from 'prop-types';
import React from 'react';
import { ListItem } from './item';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
var variantPath = getVariantPath({
  id: 'list'
});
var List = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
      As = _ref$as === void 0 ? 'ul' : _ref$as,
      withDivider = _ref.withDivider,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["as", "withDivider", "children"]);

  return _jsx(As, _objectSpread(_objectSpread({
    ref: ref,
    sx: {
      variant: variantPath(withDivider ? 'withDivider' : 'base')
    }
  }, props), {}, {
    children: children
  }));
});
List.propTypes = {
  /**
   * Optional divider can be turned on or off with this prop
   */
  withDivider: PropTypes.bool
};
List.defaultProps = {
  withDivider: false
};
List.displayName = 'List';
export { List, ListItem };